import { GridCellProps } from '@progress/kendo-react-grid';
import { TextBoxChangeEvent } from '@progress/kendo-react-inputs';
import { useCallback, useMemo } from 'react';
import GridCellBase, { useGridCellDisplayValue } from 'src/components/GridCellBase';
import NumberInput from 'src/components/NumberInput';
import useViewBudgetPeriod from 'src/hooks/useViewBudgetPeriod';
import { getBgColor } from 'src/utils/icons';

const PercentageCell = (props: GridCellProps) => {
  const { distributionType, isReadOnly } = useViewBudgetPeriod();
  const { field, dataIndex, dataItem, onChange } = props;

  const handleChange = useCallback(
    (e: TextBoxChangeEvent) => {
      onChange?.({
        dataIndex,
        dataItem,
        syntheticEvent: e.syntheticEvent,
        field,
        value: e.value === '.' || e.value === '' || !e.value ? e.value : Math.abs(Number(e.value)),
      });
    },
    [dataIndex, dataItem, field, onChange]
  );

  const { displayValue, value } = useGridCellDisplayValue(props);
  const error = useMemo(
    () => dataItem?.errors?.percentageAmount,
    [dataItem?.errors?.percentageAmount]
  );

  if (isReadOnly || distributionType !== 'Percentage') {
    return (
      <GridCellBase {...props} title={`${displayValue}%`}>
        <p className="text-left">{displayValue}%</p>
      </GridCellBase>
    );
  }

  return (
    <GridCellBase {...props} title={`${displayValue}%`} className={getBgColor(error)}>
      <NumberInput value={value} onChange={handleChange} postfix="%" valid={!error?.length} />
    </GridCellBase>
  );
};

export default PercentageCell;
